<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {delay, navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {getCategory, updateCategory} from 'src/components/cabinet/#services/blogCategories'

    export let id

    getCategory.reset()
    getCategory.send({ data: { id: +id } })

    let categoryInfo
    $: if (!categoryInfo && $getCategory.hasValue) {
        categoryInfo = $getCategory.value && JSON.parse(JSON.stringify($getCategory.value))
    }

    $: categoryName = 'title'
    let saved = false

    async function save() {
        saved = true

        if (categoryInfo.name !== '') {
            try {
                updateCategory.send({data: categoryInfo})

                showAlert.set({
                    status: 'success',
                    text: 'Category successfully updated!'
                })
            } catch (e) {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

<svelte:head>
    <title>Edit category</title>
</svelte:head>

<MainLayout title="Edit category">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="blog/categories" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-4">
                        {#if $getCategory.loading}
                            Loading...
                        {:else if $getCategory.error || !$getCategory.hasValue }
                            An error has occurred
                        {:else if $getCategory.value && categoryInfo}
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" class="form-control" bind:value={categoryInfo.name}
                                    class:is-invalid={saved && categoryInfo.name === ''}>
                            </div>
                        {/if}
                    </div>
                </div>
                <button class="btn btn-success" on:click={save}>Update</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>
